import { useState, useEffect, useRef, useCallback } from 'react';
import './item.scss';
import { useHistory, useParams } from 'react-router-dom';
import moment from 'moment';
import api from 'api';
import { useDispatch } from 'react-redux';
import { actions } from 'redux/reducers';
import Loader from 'components/loader';

function Item({
    date
} : {
    date: Date
}) {
    const history = useHistory();
    const dispatch = useDispatch();
    const params: any = useParams();
    const descriptionRef = useRef<any>(null);
    const [item, setItem] = useState<any>();
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const update = () => {
        api.calendar.event.update(params.itemId, item.Title, descriptionRef.current.innerHTML, moment(item.DueDate).format("DD MMM YYYY"), item.IsShared).then(() => {
            getData();
        })
    }

    const getData = useCallback(() => {
        const monthStart = moment(date).startOf("M")
        const monthEnd = moment(date).endOf("M")
        const startDate = moment(monthStart).startOf("W")
        const endDate = moment(monthEnd).endOf("W")
        let array: any = []
    
        api.calendar.getAll(params.clientId, new Date(monthStart.toString()), new Date(monthEnd.add(1, "d").toString())).then((data) => {
          for (let i = startDate; i.isBefore(endDate); i.add(1, "d")) {
            const events = data.Events.filter((x: any) => moment(x.DueDate).format("DD MMM YYYY") === i.format("DD MMM YYYY")).map((x: any) => {
              return {
                ...x,
                Type: "Event",
              }
            })
            const tickets = data.Tickets.filter((x: any) => moment(x.DueDate).format("DD MMM YYYY") === i.format("DD MMM YYYY")).map((x: any) => {
              return {
                ...x,
                Type: "Ticket",
                IsShared: true
              }
            })
    
            array.push({
              key: i.toString(),
              data: events.concat(tickets),
            })
          }
          dispatch(actions.calendar.set(array));
        })
      }, [date, params.clientId, dispatch])

    useEffect(() => {
        if (params.itemId) {
            setLoading(true);
            api.calendar.event.get(params.itemId).then(data => {
                setLoading(false);
                setItem(data);
                setOpen(true);
            });
        } else {
            setOpen(false);
        }
    }, [params.itemId])

    return (
        <>
            <div className={`calendar-item ${open ? 'open' : ''}`}>
                <div className="calendar-item-header">
                    <i className="fal fa-times" onClick={history.goBack}></i>
                    <input 
                        type="text" 
                        value={item?.Title || ''} 
                        onChange={(e) => setItem({
                            ...item,
                            Title: e.currentTarget.value
                        })} 
                        onBlur={update}
                    />
                </div>
                <div className="calendar-item-body">
                    <div className="input-group">
                        <label>Description</label>
                        <div 
                            id="item-description" 
                            ref={descriptionRef}
                            contentEditable={true} 
                            title="Event Description" 
                            onBlur={update} 
                            suppressContentEditableWarning={true}
                            dangerouslySetInnerHTML={{__html: item?.Description! || ''}}>
                        </div>
                    </div>
                    <div className="input-group">
                        <label>Due Date</label>
                        <input 
                            type="date" 
                            value={item?.DueDate ? moment(item?.DueDate).format("YYYY-MM-DD") : ''} 
                            onChange={(e) => setItem({
                                ...item,
                                DueDate: new Date(e.currentTarget.value)
                            })} 
                            onBlur={update}
                        />
                    </div>
                    <div className="input-group shared">
                        <input type="checkbox" id="check-calendar-item-shared" checked={item?.IsShared || false} onChange={() => {
                            setItem({
                                ...item,
                                IsShared: !item.IsShared
                            });
                            setTimeout(() => {
                                update();
                            }, 0);
                        }} 
                        />
                        <label htmlFor="check-calendar-item-shared">Shared</label>
                    </div>
                </div>
            </div>
            <Loader show={loading} />
        </>
    )
}

export default Item;